module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-up-dd2f2523.svg";